import { call, put, takeLatest } from 'redux-saga/effects'
import { PayloadAction } from '@reduxjs/toolkit'
import apiCall from '../helpers/apiCall'
import { GET } from '../consts/methods'
import {
  FETCH_MOTORBIKE_PHOTOS,
  FETCH_MOTORBIKE_PHOTOS_FAILURE,
  FETCH_MOTORBIKE_PHOTOS_SUCCESS,
  MotorbikePhoto
} from 'src/redux/photosReducer'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* FetchMotorbikePhotosFlow(action: PayloadAction<string>): Generator<any, void, any> {
  try {
    const response: { photos: MotorbikePhoto[] } = yield call(apiCall, {
      endpoint: `/dealers_api/motorbikes/${action.payload}/photos`,
      api: 'market-api',
      method: GET,
      params: {}
    })
    yield put(FETCH_MOTORBIKE_PHOTOS_SUCCESS({ motorbikeId: action.payload, photos: response.photos }))
  } catch (error) {
    yield put(FETCH_MOTORBIKE_PHOTOS_FAILURE())
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* FetchMotorbikePhotosSaga(): Generator<any, void, any> {
  yield takeLatest(FETCH_MOTORBIKE_PHOTOS, FetchMotorbikePhotosFlow)
}
